<!--  Only Large and Normal Desktop HTML5 Goes here... -->
<!--<div *ngIf='screenWidth >= 1230'> -->
<div *ngIf='screenWidth > 767'> 
  <!--<div>-->
  <!--<div class="visible-lg" (window:orientationchange)="screenRotate($event)">-->
    <div class="bmw-lg-login-card">

        
      <div class="flex-container row">
        <div class="bmw-lg-login flex-50">
            <div class="bmw-lg-title">Login</div>
            <div>
              Verify your username and password to select a payment plan. New User? <a [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [routerLink]='["../signup"]'><b>SignUp</b></a>
            </div>
           

            <form [formGroup]='loginForm' (ngSubmit)='login(loginForm)' class="bmw-lg-login-form">
              <label for="username">Username</label>
              <br>
              <input type="text" name="qid" id="qid" formControlName="qid" Username/>
              <!-- <small *ngIf="loginForm.get('email').hasError('required') && loginForm.get('email').touched">Required</small> -->
              
              <div>
                <label for="password">Password</label>
                <div class="bmw-toggle-password-display pointer" (click)='togglePasswordDisplay()' style="margin-top:27px">
                  <span class="strike" *ngIf='!show'></span>
                  <i style="font-size: 20px; vertical-align:middle" class="material-icons">remove_red_eye</i>
                  <span [ngStyle]='{"color":  (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{show ? "Hide" : "Show"}}</span>
                </div>
                <br>
                <input #inputPassword type="password" name="password" id="password" formControlName="password"/>
                <!-- <small *ngIf="loginForm.get('password').hasError('required') && loginForm.get('password').touched">Required</small> -->
              </div>
              <br>
              <small style="color: red; font-size : 14px;">{{errorMessage}}</small>
              <button type='submit' [ngStyle]='{"background-color":  (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-submit-button">Log In</button>
            </form>

            <!-- 
            <label>Username</label>
            <br>
            <div>
              <input class="bmw-paypal" type="text" [(ngModel)]='qid' placeholder="Enter username" name="qid" id="qid">
            </div>
            <label style="margin-top:20px" for="newPassword">Password</label>
            <br>
            <input class="bmw-paypal" type="password" placeholder="Enter password" name="newPassword" id="newPassword" [(ngModel)]="password">
            <br>
            <small style="color: #ff0000">{{errorMessage}}</small>
            <br>
            <button (click)='verifyLoginUser()' [disabled]='!qid || !password' [ngStyle]='{"background-color":  (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
        class="bmw-submit-button" style="padding:7px;margin-top:20px">Submit</button>
             -->
          <br>
          <div class="flex-container row">
            <div [ngStyle]='{"color":  (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-login-links pointer flex-50" data-toggle="modal"
              data-target="#forgotUsername">
              Forgot Username?
            </div>
            <div [routerLink]='["../reset-password"]' [ngStyle]='{"color":  (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-login-links pull-right pointer flex-50">
              Forgot password?
            </div>
          </div>
        </div>
        <div class="bmw-lg-suscription flex-50">
          <div class="bmw-lg-title">Subscription</div>
          <div class="bmw-lg-subscription-info">
            <span>Registration and payment are required to enter this site.
              
              <br>Already registered? Provide your login information to the left and select the submit button.
              
              <br>Unregistered users please signup and you will be redirected to select one of the plans below on login.</span>
          </div>
          <div *ngFor="let tisSubscription of tisSubscriptions" class="bmw-lg-subscription-plan flex-container row">
            <div class="flex-5">
              <div class="bmw-lg-subscription-oval" [ngStyle]='{"background-color":  (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                ${{tisSubscription.price}}
              </div>
            </div>
            <div class="bmw-lg-subscription-plan-info flex-55">
              {{tisSubscription.description}}
            </div>
          </div>
        </div>
      </div>
      <!-- START: Site Features Section -->
      <div class="flex-container">
          <div class="bmw-login-site-features flex-100" style="text-align: center;">
            <img *ngIf="is3rdParty" src="assets/images/parts24logo.png" alt="Parts24 Logo" style="max-width: 200px; margin-bottom: 20px; cursor: pointer;" (click)="openParts24Link()">
            <p>For more information about site features select the button below.</p>
            <a href="assets/site_information.pdf" alt="Site Features"><fa-icon [icon]="faFilePdf"></fa-icon> Site Features</a>
            </div>
      </div>
    <!-- END: Site Features Section -->
    </div>
    <div class="bmw-lg-login-messages">
      <div class="bmw-lg-title">Messages</div>
      <div class="bmw-lg-messages">
        <div *ngFor='let message of allMessages'>
          <div>{{message?.createdDate | date}}</div>
          <div class="bmw-login-message-desc">{{message?.description}}</div>
        </div>
      </div>
    </div>
    <!-- START: System Requirements Section -->
    <div class="bmw-lg-login-system-requirements">
      <div class="bmw-lg-title">System Requirements</div>
      <div class="bmw-lg-system-requirements">
        <div class="bmw-login-system-requirements-desc"><a href="assets/system_requirements.pdf" alt="View system requirements for J2532"><b>Click here</b></a> to view the system requirements necessary for vehicle reprogramming and diagnostics using J2534.</div>
        <div class="bmw-login-system-requirements-desc">Complete system requirement details can be found visiting <a href="{{getMappingUrl('microsoft')}}" alt="Microsoft"><b>Microsoft&reg;</b></a> and <a href="{{getMappingUrl('adobe')}}" alt="Adobe"><b>Adobe&reg;</b></a>.</div>
      </div>
    </div>
    <!-- END: Sytem Requirements Section -->
    
    <!-- START: Helpful links Section -->
      <div class="bmw-lg-login-card">
        <div class="flex-container row">
          <div class="bmw-lg-login flex-50">
              <div class="bmw-lg-title">Helpful Links</div>
              <div class="bmw-login-system-requirements-desc bmw-xs"><a href="{{getMappingUrl('productOrdering')}}" alt="View product order system"><b>API International</b></a> - Special tool and diagonostic equipment can be purchased here.</div>
              <div class="bmw-login-system-requirements-desc bmw-xs"><a href="{{getMappingUrl('modelMap')}}" alt="Model Map"><b>Model Map</b></a> - for BMW,MINI and ROLLSROYCE vehicles.</div>
          </div>
          <div class="bmw-lg-suscription flex-50">
            <div class="bmw-lg-title">Contact Support</div>
            <div class="bmw-lg-subscription-info">
                <div class="bmw-login-system-requirements-desc bmw-xs"><a href="{{getMappingUrl('ossSupport')}}" alt="Contact AOS Support"><b>Contact AOS Support</b></a> - For AOS software installation support </div>
                <div class="bmw-login-system-requirements-desc bmw-xs"><a href="{{getMappingUrl('tisSupport')}}" alt="Contact TIS Support"><b>Contact TIS Support</b></a> - For general Website/Account questions </div>
            </div>
          </div>  
        </div>
      </div>
      <!-- END: Helpful links Section -->

    <div class="modal" id="forgotUsername" role="dialog" #forgotUsernameModal>
      <div class="modal-dialog">
        <div class="modal-content bmw-login-lg-modal">
          <div class="modal-body">
            <div class="pull-right flex-container row">
              <i class="material-icons pointer" data-dismiss="modal">close</i>
            </div>
            <div class="bmw-login-modal-title">Forgot Username?</div>
            <small style="color:black">Please submit your email and check your inbox for an email with your account information</small>
            <div class="bmw-login-modal">
              <label>Email*</label>
              <input type="email" [(ngModel)]='userEmail'>
            </div>
            <small style="color:red">{{forgotUserErrorMessage}}</small>
            <button type="button" [disabled]='!userEmail' class="bmw-login-modal-button" [ngStyle]='{"background-color":  (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
              (click)='submitEmail(userEmail)'>SUBMIT</button>
          </div>
        </div>
      </div>
    </div>
  <!--</div>-->
</div>

<!--  Only Mobile HTML5 Goes here... -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div class="bmw-xs-login-card" (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-login bmw-xs-login-card bmw-xs flex-container row">
      <div class="bmw-xs-title">Login</div>
      <div>
        Verify your username and password to select a payment plan. New User? <a [ngStyle]='{"color":  (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [routerLink]='["../signup"]'>SignUp</a>
      </div>
      <form [formGroup]='loginForm' (ngSubmit)='login(loginForm)' class="bmw-lg-login-form">
        <label for="qid">Username</label>
        <br>
        
        <input type="text" placeholder="Enter username" name="qid" id="qid" formControlName="qid">
        <br>
        <div style="margin-top:5px">
          <label for="password">Password</label>
          <div class="bmw-toggle-password-display pointer" (click)='togglePasswordDisplay()'>
            <span class="strike" *ngIf='!show'></span>
            <i style="font-size: 20px; vertical-align:middle" class="material-icons">remove_red_eye</i>
            <span [ngStyle]='{"color":  (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{show ? "Hide" : "Show"}}</span>
          </div>
          <br>
          <input #inputPassword type="password" placeholder="Enter password" name="password" id="password" formControlName="password">
          
        </div>
        <br>
        <small style="color: red">{{errorMessage}}</small>
        <button type='submit' [disabled]="loginForm.invalid" [ngStyle]='{"color":  (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-submit-button">Log In</button>
      </form>
      <div class="flex-container row">
        <label class="bmw-onoffswitch-checkbox">Remember Email
          <input [(ngModel)]="rememberUserEmail" type="checkbox" name="onoffswitch">
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="flex-container row">
        <div [ngStyle]='{"color":  (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-login-links flex-50" data-toggle="modal"
          data-target="#forgotUsername">
          Forgot Username?
        </div>
        <div [ngStyle]='{"color":  (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-login-links pull-right flex-50">
          Forgot password?
        </div>
      </div>
      
        <!-- START: Site Features Section -->
        <div class="flex-container">
            <div class="bmw-login-site-features flex-120" style="margin: 0 -30px;">
              <p>For more information about site features select the button below.</p>
              <a href="assets/site_information.pdf" alt="Site Features"><fa-icon [icon]="faFilePdf"></fa-icon> Site Features</a>
              </div>
        </div>
      <!-- END: Site Features Section -->
    </div>
    <div class="bmw-xs-suscription bmw-xs-login-card flex-container row">
      <div class="bmw-xs-title">Subscription</div>
      <div class="bmw-lg-subscription-info">
        <span>Registration and payment are required to enter this site.
          <br>
          <br>Already registered? Provide your login information to the left and select the Log In button.
          <br>
          <br>Unregistered users please signup and you will be redirected to select one of the plans below on login.</span>
      </div>
      <div *ngFor="let tisSubscription of tisSubscriptions" class="bmw-lg-subscription-plan flex-container row">
        <div class="flex-25">
          <div class="bmw-lg-subscription-oval" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
            ${{tisSubscription.price}}
          </div>
        </div>
        <div class="bmw-lg-subscription-plan-info flex">
          ${{tisSubscription.description}}
        </div>
        <div [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-submit-button bmw-lg-sub flex-30">
          Sign Up
        </div>
      </div>
    </div>
    <div class="bmw-lg-login-messages bmw-xs">
      <div class="bmw-xs-title">Messages</div>
      <div class="bmw-lg-messages">
        <div *ngFor='let message of allMessages'>
          <div>{{message?.createdDate | date}}</div>
          <div class="bmw-login-message-desc">{{message?.description}}</div>
        </div>
      </div>
    </div>
    <div class="modal" id="forgotUsername" role="dialog" #forgotUsernameModal>
      <div class="modal-dialog">
        <div class="modal-content bmw-login-xs-modal">
          <div class="modal-body">
            <div class="pull-right flex-container row">
              <i class="material-icons pointer" data-dismiss="modal">close</i>
            </div>
            <div class="bmw-login-modal-title xs">Forgot Username?</div>
            <small style="color:black">Please submit your email and check your inbox for an email with your account information</small>
            <div class="bmw-login-modal">
              <label>Email*</label>
              <input type="email" [(ngModel)]='userEmail'>
            </div>
            <small style="color:red">{{forgotUserErrorMessage}}</small>
            <button type="button" [disabled]='!userEmail' class="bmw-login-modal-button" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
              (click)='submitEmail(userEmail)'>SUBMIT</button>
          </div>
        </div>
      </div>
    </div>
     <!-- START: System Requirements Section -->
     <div class="bmw-lg-login-system-requirements bmw-xs">
        <div class="bmw-lg-title">System<br />Requirements</div>
        <div class="bmw-lg-system-requirements">
            <div class="bmw-login-system-requirements-desc bmw-xs"><a href="assets/system_requirements.pdf" alt="View system requirements for J2532"><b>Click here</b></a> to view the system requirements necessary for vehicle reprogramming and diagnostics using J2534.</div>
            <div class="bmw-login-system-requirements-desc bmw-xs">Complete system requirement details can be found visiting <a href="{{getMappingUrl('microsoft')}}" alt="Microsoft"><b>Microsoft&reg;</b></a> and <a href="{{getMappingUrl('adobe')}}" alt="Adobe"><b>Adobe&reg;</b></a>.</div>
          </div>
      </div>
      <!-- END: Sytem Requirements Section -->

     
      <!-- START: Helpful links Section -->
      <div class="bmw-lg-login-system-requirements bmw-xs">
         <div class="bmw-lg-title">Helpful Links</div>
          <div class="bmw-login-system-requirements-desc bmw-xs"><a href="{{getMappingUrl('productOrdering')}}" alt="View product order system"><b>API International</b></a> - Special tool and diagonostic equipment can be purchased here.</div>
          <div class="bmw-login-system-requirements-desc bmw-xs"><a href="{{getMappingUrl('modelMap')}}" alt="Model Map"><b>Model Map</b></a> - for BMW,MINI and ROLLSROYCE vehicles.</div>
        
          <div class="bmw-lg-title">Contact Support</div>
          <div class="bmw-lg-subscription-info">
              <div class="bmw-login-system-requirements-desc bmw-xs"><a href="{{getMappingUrl('ossSupport')}}" alt="Contact AOS Support"><b>Contact AOS Support</b></a> - For AOS software installation support</div>
              <div class="bmw-login-system-requirements-desc bmw-xs"><a href="{{getMappingUrl('tisSupport')}}" alt="Contact TIS Support"><b>Contact TIS Support</b></a> - For general Website/Account questions</div>
          </div>
         
      </div>
      <!-- END: Helpful links Section -->
  </div>
</div>
